import { render } from "./AddFolderModal.vue?vue&type=template&id=7ddafe13&scoped=true&ts=true"
import script from "./AddFolderModal.vue?vue&type=script&lang=ts"
export * from "./AddFolderModal.vue?vue&type=script&lang=ts"

import "./AddFolderModal.vue?vue&type=style&index=0&id=7ddafe13&lang=scss&scoped=true"
import "./AddFolderModal.vue?vue&type=style&index=1&id=7ddafe13&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ddafe13"]])

export default __exports__